var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtwork2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 557,
    height: 548,
    viewBox: "0 0 557 548",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-976 -396) translate(976 396)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    fillRule: "nonzero",
    d: "M416.345 132.556c-41.564-6.633-88.895-10.173-138.188-10.173-45.111 0-88.573 2.96-127.47 8.541.009-.597.017-1.195.044-1.792C152.876 57.022 212.18-.195 284.32.246c72.14.44 130.742 58.378 132.006 130.509.009.606.018 1.203.018 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    fillRule: "nonzero",
    d: "M300.936 1.197c-37.309-5.04-75.004 5.983-103.72 30.33-28.716 24.347-45.756 59.732-46.887 97.362-.027.598-.036 1.195-.044 1.792 11.556-1.658 23.523-3.079 35.808-4.265 3.1-63.963 51.387-116.612 114.843-125.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    fillRule: "nonzero",
    d: "M474.455 143.093c-19.133-5.186-38.539-9.305-58.128-12.338-32.108-4.976-64.477-8.087-96.945-9.317-13.525-.553-27.299-.838-41.225-.838-11.037 0-21.985.178-32.781.535-31.67.936-63.266 3.605-94.645 7.997-23.228 3.199-46.23 7.862-68.87 13.961C29.072 157.688 0 177.248 0 198.163c0 20.916 29.073 40.476 81.86 55.07 37.124 10.27 82.895 17.27 132.767 20.479 20.586 1.337 41.867 2.014 63.53 2.014 21.736 0 43.088-.686 63.736-2.023 45.388-2.933 87.379-9.005 122.523-17.83.187-.054.366-.099.553-.144 2.371-.588 4.707-1.203 7.016-1.818.83-.232 1.65-.455 2.47-.678.046-.019.094-.034.142-.044.785-.214 1.56-.437 2.336-.651 1.552-.446 3.085-.883 4.591-1.338.072-.017.134-.035.197-.053 1.31-.392 2.594-.785 3.869-1.177 1.043-.33 2.077-.65 3.102-.98.75-.241 1.49-.482 2.22-.723.535-.178 1.061-.347 1.578-.526.705-.231 1.41-.472 2.104-.713.295-.098.589-.196.874-.303.669-.223 1.32-.455 1.97-.687.705-.25 1.409-.508 2.104-.757.58-.205 1.16-.42 1.73-.633.481-.188.954-.366 1.435-.544 1.31-.49 2.595-.999 3.86-1.498.634-.258 1.267-.508 1.89-.767.616-.25 1.24-.508 1.846-.766.998-.42 1.98-.838 2.942-1.257.464-.214.937-.42 1.391-.615.348-.161.686-.313 1.034-.473.25-.107.5-.223.74-.339.9-.41 1.792-.829 2.666-1.248 3.352-1.605 6.481-3.245 9.387-4.921 18.232-10.44 27.852-22.021 27.852-34.057 0-20.915-29.073-40.475-81.86-55.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "nonzero",
    d: "M473.973 251.521c-37.167 10.28-83.063 17.278-133.07 20.461-20.336 1.293-41.357 1.961-62.745 1.961-21.317 0-42.268-.66-62.541-1.952-50.087-3.174-96.054-10.172-133.275-20.47-51.95-14.371-80.559-33.316-80.559-53.358 0-1.77.225-3.534.66-5.25 4.546-18.081 32.514-35.002 79.899-48.108 22.468-6.052 45.295-10.688 68.345-13.88 31.567-4.417 63.353-7.096 95.215-8.025 10.627-.347 21.38-.52 32.256-.517 13.738 0 27.325.277 40.68.812 32.657 1.219 65.214 4.344 97.507 9.36 19.42 3.02 38.659 7.11 57.628 12.25 47.376 13.106 75.335 30.018 79.89 48.09.443 1.72.669 3.49.669 5.268 0 20.042-28.61 38.987-80.559 53.358z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6369D1",
    fillRule: "nonzero",
    d: "M555.807 198.975c0 11.91-9.816 23.18-27.344 33.245-2.915 1.676-6.053 3.316-9.387 4.921-.874.419-1.765.838-2.666 1.248-.24.116-.49.232-.74.339-.348.16-.686.312-1.034.472-.455.197-.927.402-1.39.616-.964.419-1.944.838-2.943 1.257-.606.258-1.23.517-1.846.766-.623.259-1.256.508-1.89.767-1.265.5-2.55 1.007-3.86 1.498-.481.178-.954.356-1.435.544-.57.214-1.15.428-1.73.633-.695.25-1.4.508-2.104.757-.65.232-1.301.464-1.97.687-.285.107-.58.205-.874.303-.695.24-1.4.481-2.104.713-.517.179-1.043.348-1.578.526-.73.24-1.471.482-2.22.722-1.025.33-2.06.651-3.102.981-1.275.392-2.559.785-3.87 1.177-.062.018-.124.036-.196.053-1.506.455-3.04.892-4.591 1.338-.776.214-1.551.437-2.336.65-.049.011-.096.026-.142.045-.82.223-1.64.446-2.47.678-2.3.606-4.645 1.221-7.016 1.818-.187.045-.366.09-.553.143-34.19 8.54-76.137 14.764-122.559 17.768-20.335 1.31-41.536 2.006-63.316 2.006-21.976 0-43.355-.704-63.852-2.041-122.353-7.98-213.414-38.363-213.414-74.63.01-2.207.346-4.4.998-6.509.054.152.107.295.17.446 12.722 33.415 103.007 60.42 220.154 67.008 17.947 1.016 36.535 1.542 55.56 1.542 19.106 0 37.766-.535 55.783-1.551 117.05-6.616 207.246-33.629 219.923-67.017.214-.535.402-1.07.562-1.604.904 2.461 1.371 5.062 1.382 7.685zM81.726 189.378c-14.838 0-30.607-3.192-30.607-9.108 0-5.917 15.77-9.109 30.607-9.109s30.607 3.192 30.607 9.109c0 5.916-15.77 9.108-30.607 9.108z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9992FF",
    fillRule: "nonzero",
    d: "M81.726 172.944c-16.986 0-28.824 3.86-28.824 7.326 0 3.464 11.838 7.325 28.824 7.325 16.986 0 28.824-3.86 28.824-7.325 0-3.465-11.838-7.326-28.824-7.326z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6369D1",
    fillRule: "nonzero",
    d: "M145.025 231.28c-14.838 0-30.607-3.192-30.607-9.108 0-5.917 15.77-9.11 30.607-9.11s30.606 3.193 30.606 9.11c0 5.916-15.769 9.108-30.606 9.108z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9992FF",
    fillRule: "nonzero",
    d: "M145.025 214.846c-16.987 0-28.824 3.86-28.824 7.326 0 3.464 11.837 7.325 28.824 7.325 16.986 0 28.823-3.86 28.823-7.325 0-3.465-11.837-7.326-28.823-7.326z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6369D1",
    fillRule: "nonzero",
    d: "M474 189.378c-14.838 0-30.607-3.192-30.607-9.108 0-5.917 15.769-9.109 30.606-9.109 14.838 0 30.607 3.192 30.607 9.109 0 5.916-15.77 9.108-30.607 9.108z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9992FF",
    fillRule: "nonzero",
    d: "M474 172.944c-16.987 0-28.824 3.86-28.824 7.326 0 3.464 11.837 7.325 28.823 7.325 16.987 0 28.824-3.86 28.824-7.325 0-3.465-11.837-7.326-28.824-7.326z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6369D1",
    fillRule: "nonzero",
    d: "M410.7 231.28c-14.837 0-30.606-3.192-30.606-9.108 0-5.917 15.77-9.11 30.607-9.11s30.607 3.193 30.607 9.11c0 5.916-15.77 9.108-30.607 9.108z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9992FF",
    fillRule: "nonzero",
    d: "M410.7 214.846c-16.986 0-28.823 3.86-28.823 7.326 0 3.464 11.837 7.325 28.824 7.325 16.986 0 28.823-3.86 28.823-7.325 0-3.465-11.837-7.326-28.823-7.326z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6369D1",
    fillRule: "nonzero",
    d: "M277.863 250.894c-14.838 0-30.607-3.192-30.607-9.109 0-5.916 15.77-9.108 30.607-9.108s30.607 3.192 30.607 9.108c0 5.917-15.77 9.109-30.607 9.109z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9992FF",
    fillRule: "nonzero",
    d: "M277.863 234.46c-16.987 0-28.824 3.86-28.824 7.325 0 3.465 11.837 7.326 28.824 7.326 16.986 0 28.823-3.861 28.823-7.326 0-3.465-11.837-7.325-28.823-7.325z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.426,
    cy: 400.817,
    r: 37.455,
    fill: "#333",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "nonzero",
    d: "M269.423 429.388L289.81 429.388 289.81 440.767 269.423 440.767z",
    transform: "rotate(-26.601 279.616 435.077)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.536,
    cy: 438.477,
    fill: "#333",
    fillRule: "nonzero",
    rx: 3.556,
    ry: 9.482,
    transform: "rotate(-56.601 267.536 438.477)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "nonzero",
    d: "M315.547 424.884L326.925 424.884 326.925 445.271 315.547 445.271z",
    transform: "rotate(-63.399 321.236 435.077)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 333.316,
    cy: 438.477,
    fill: "#333",
    fillRule: "nonzero",
    rx: 9.482,
    ry: 3.556,
    transform: "rotate(-33.399 333.316 438.477)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.804,
    cy: 391.656,
    r: 12.801,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 297.892,
    cy: 386.175,
    fill: "#333",
    fillRule: "nonzero",
    rx: 4.249,
    ry: 4.279,
    transform: "rotate(-45 297.892 386.175)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6369D1",
    d: "M329.973 360.07c.563-13.867-11.388-25.612-26.693-26.233-15.306-.622-28.17 10.115-28.733 23.982-.563 13.866 10.076 17.017 25.381 17.638 15.306.622 29.482-1.52 30.045-15.387z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 339.364,
    cy: 406.22,
    fill: "#333",
    fillRule: "nonzero",
    rx: 5.879,
    ry: 18.728,
    transform: "rotate(-40.645 339.364 406.22)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.592,
    cy: 406.22,
    fill: "#333",
    fillRule: "nonzero",
    rx: 18.728,
    ry: 5.879,
    transform: "rotate(-49.355 261.592 406.22)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M310.713 415.578c.844 4.637-2.23 9.08-6.868 9.925-4.637.844-9.08-2.231-9.924-6.868l-.003-.017c-.84-4.637 2.746-6.279 7.384-7.118 4.638-.84 8.572-.56 9.411 4.078z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    fillRule: "nonzero",
    d: "M237.147 440.66c-.985 0-1.783-.799-1.783-1.783V333.676c0-.985.798-1.783 1.783-1.783.985 0 1.783.798 1.783 1.783v105.2c0 .985-.798 1.784-1.783 1.784zM210.401 535.162c-.985 0-1.783-.799-1.783-1.783v-76.672c0-.985.798-1.783 1.783-1.783.985 0 1.783.798 1.783 1.783v76.672c0 .984-.798 1.783-1.783 1.783z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    fillRule: "nonzero",
    d: "M279.049 471.863c-.985 0-1.783-.798-1.783-1.783v-105.2c0-.985.798-1.784 1.783-1.784.985 0 1.783.799 1.783 1.783V470.08c0 .985-.798 1.783-1.783 1.783z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    fillRule: "nonzero",
    d: "M253.195 547.643c-.985 0-1.783-.798-1.783-1.783v-42.793c0-.985.798-1.783 1.783-1.783.984 0 1.783.798 1.783 1.783v42.793c0 .985-.799 1.783-1.783 1.783zM289.747 328.327c-.984 0-1.783-.799-1.783-1.783V283.75c0-.985.799-1.783 1.783-1.783.985 0 1.783.798 1.783 1.783v42.794c0 .984-.798 1.783-1.783 1.783zM200.594 347.049c-.984 0-1.783-.798-1.783-1.783v-42.794c0-.984.799-1.783 1.783-1.783.985 0 1.783.799 1.783 1.783v42.794c0 .985-.798 1.783-1.783 1.783zM355.72 351.507c-.984 0-1.782-.799-1.782-1.784V306.93c0-.985.798-1.783 1.783-1.783.984 0 1.783.798 1.783 1.783v42.793c0 .985-.799 1.784-1.783 1.784zM352.155 485.236c-.985 0-1.783-.798-1.784-1.783v-51.709c0-.984.799-1.783 1.784-1.783.984 0 1.783.799 1.783 1.783v51.709c0 .985-.799 1.783-1.783 1.783zM316.493 530.704c-.984 0-1.783-.798-1.783-1.783V452.25c0-.984.799-1.783 1.783-1.783.985 0 1.783.799 1.783 1.783v76.672c0 .985-.798 1.783-1.783 1.783zM323.626 399.65c-.985 0-1.783-.8-1.784-1.784v-105.2c0-.985.799-1.784 1.784-1.784.984 0 1.783.799 1.783 1.784v105.2c0 .985-.799 1.783-1.783 1.783z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtwork2);
export default __webpack_public_path__ + "static/media/artwork2.46a7ad496d616d42bf29fc13cba03bbe.svg";
export { ForwardRef as ReactComponent };